import axios from 'axios';
import { createModel,  getModel, postModel, updateModel } from '../../../services/api.service';
import { IProfileReturn, IJoinProfile, IJoinProfileReturn, IListProfileReturn, IProfile, IUploadReturn, IFile, IFileU } from '../interfaces/profile';

/**
 * Get all profiles
 */
export const getAllProfiles = async (page: number, limit: number, search: string): Promise<IListProfileReturn> => {
    const urlModel = `profiles?limit=${limit}&page=${page}&search=${search}`;
    const data = await getModel(urlModel);
    return data;
};

/**
 * Get profile by sport name
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getProfile = async (): Promise<IProfileReturn> => {
    const urlModel = `users/profile`;
    const data = await getModel(urlModel);
    return data;
};


/**
 * Create a join Game
 * @param values Data to create a join Game
 */
 export const updateProfile = async (values: IProfile): Promise<IProfileReturn> => {
    console.log('llegue', values);

    const result = await updateModel(`users/profile`)(values);
    return result;
};


/**
 * Create a join Profile
 * @param values Data to create a join Profile
 */
 export const addTeam = async (values: IJoinProfile): Promise<IJoinProfileReturn> => {
    const result = await createModel(`users/profile/team`)(values);
    return result;
};


/**
 * Get  signe Url valid.
 */
 export const getSignedUrl = async (file: IFile): Promise<IUploadReturn> => {
    const result = await postModel('uploads')(file);
    return result;
};

/**
 * Update project
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const uploadFile = async (path: string, contentType: string, image: IFileU): Promise<any> => {
    const result = await axios.put(`${path}`, image, {
        headers: {
            'Content-Type': contentType,
        },
    });

    return result;
};